module.exports = __webpack_public_path__ + "static/media/street6.63438811.jpg";